import { useState } from "react";
import { Menu, X } from "lucide-react";

const Header = ({ isScrolled }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const navLinks = [
    { href: "#accueil", label: "Accueil" },
    { href: "#apropos", label: "À propos" },
    { href: "#services", label: "Services" },
    { href: "#realisations", label: "Réalisations" },
    { href: "#temoignages", label: "Témoignages" },
    { href: "#contact", label: "Contact" },
  ];

  const scrollToSection = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? "glass border-b border-white/20 shadow-sm"
          : "bg-transparent"
      }`}
      data-testid="header"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <nav className="flex items-center justify-between h-20 gap-12">
          {/* Logo */}
          <a
            href="#accueil"
            onClick={(e) => scrollToSection(e, "#accueil")}
            className="flex items-center gap-2"
            data-testid="logo-link"
          >
            <span className="font-heading text-2xl font-bold text-deep-oak">
              TT Wood
            </span>
          </a>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => scrollToSection(e, link.href)}
                className="nav-link text-sm font-medium"
                data-testid={`nav-${link.href.replace("#", "")}`}
              >
                {link.label}
              </a>
            ))}
          </div>

          {/* CTA Button */}
          <a
            href="#contact"
            onClick={(e) => scrollToSection(e, "#contact")}
            className="hidden md:inline-flex btn-primary text-sm"
            data-testid="header-cta"
          >
            Demander un devis
          </a>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2 text-deep-oak"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Toggle menu"
            data-testid="mobile-menu-toggle"
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </nav>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div
            className="md:hidden absolute top-20 left-0 right-0 bg-white shadow-lg border-t border-gray-100 animate-fade-in"
            data-testid="mobile-menu"
          >
            <div className="flex flex-col py-4">
              {navLinks.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={(e) => scrollToSection(e, link.href)}
                  className="px-6 py-3 text-deep-oak hover:bg-warm-cream transition-colors"
                  data-testid={`mobile-nav-${link.href.replace("#", "")}`}
                >
                  {link.label}
                </a>
              ))}
              <div className="px-6 py-4">
                <a
                  href="#contact"
                  onClick={(e) => scrollToSection(e, "#contact")}
                  className="btn-primary block text-center text-sm"
                  data-testid="mobile-cta"
                >
                  Demander un devis
                </a>
              </div>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
